import { Injectable, ApplicationRef, ComponentRef, createComponent, EnvironmentInjector } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BodyRendererService {

    private componentRef!: ComponentRef<any>;

    constructor(
        private appRef: ApplicationRef,
        private environmentInjector: EnvironmentInjector
    ) { }

    appendToBody(component: any): ComponentRef<any> {

        this.componentRef = createComponent(component, {
            environmentInjector: this.environmentInjector,
        });
        
        this.appRef.attachView(this.componentRef.hostView);
        const domElem = this.componentRef.location.nativeElement;
        document.body.appendChild(domElem);
        return this.componentRef;
    }

    removeFromBody(): void {
        if (this.componentRef) {
            this.appRef.detachView(this.componentRef.hostView);
            this.componentRef.destroy();
        }
    }
}